<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate-pulse"
    [fullScreen]="true"></ngx-spinner> -->

<ngx-spinner size="medium" [fullScreen]="true" template="<img src='../assets/loader2.gif' style='height: 100px' />"></ngx-spinner>


<router-outlet></router-outlet>